import Box from '../../../Box';
var Content = Box;
Content.displayName = 'Card.Content';
export default Content;